import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { jwtDecode } from "jwt-decode";

@Injectable({ providedIn: "root" })
export class AuthTokenGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = sessionStorage.getItem("token");

    if (!token) {
      return this.navigateToLogin(state);
    }

    try {
      const decodedToken = jwtDecode(token);

      if (decodedToken.exp && Date.now() >= decodedToken.exp * 1000) {
        throw new Error("Token expirado");
      }

      return true;
    } catch (error) {
      console.error("Error al validar el token:", error);
      return this.navigateToLogin(state);
    }
  }

  private navigateToLogin(state: RouterStateSnapshot): boolean {
    this.router.navigate(["/auth/oauth-redirect"], {
      queryParams: { returnUrl: state.url },
    });

    return false;
  }
}
